export const frontmatter = {
    "draft": true,
    "title": "Integración GitHub",
    "description": "Autenticación y acceso a OnnIA mediante cuenta de GitHub.",
    "sidebar_label": "GitHub",
    "sidebar_group": "guías",
    "sidebar_order": 5
}

export const toc = []